function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input, InputGroup, Button } from 'module-tsl-ui-elements';

var DiscountCode = /*#__PURE__*/function (_Component) {
  _inherits(DiscountCode, _Component);

  var _super = _createSuper(DiscountCode);

  function DiscountCode() {
    _classCallCheck(this, DiscountCode);

    return _super.apply(this, arguments);
  }

  _createClass(DiscountCode, [{
    key: "onShowDiscountCodeInput",
    value: function onShowDiscountCodeInput(e) {
      e.preventDefault();
      this.props.showDiscountCodeInput();
    }
  }, {
    key: "onApplyDiscount",
    value: function onApplyDiscount() {
      this.props.setInputFocus(false);
      this.props.reloadCheckout(true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          discountCodeError = _this$props.discountCodeError,
          discountCode = _this$props.discountCode,
          inputFocused = _this$props.inputFocused,
          discountCodeApplied = _this$props.discountCodeApplied,
          checkoutLoading = _this$props.checkoutLoading,
          isPostalCodeNeeded = _this$props.isPostalCodeNeeded,
          isEmailConfirmationNeeded = _this$props.isEmailConfirmationNeeded;

      if (discountCodeApplied) {
        var discountCodeAppliedSection = '';

        if (isPostalCodeNeeded || isEmailConfirmationNeeded) {
          discountCodeAppliedSection = /*#__PURE__*/React.createElement("p", {
            className: "text text--xs text--discreet margin-top-xs margin-bottom-sm padding-right-md padding-left-md"
          }, /*#__PURE__*/React.createElement("span", {
            className: "icon-text-container"
          }, /*#__PURE__*/React.createElement("i", {
            className: "icon icon-info icon-green icon-sm"
          }), "Please complete highlighted field(s) to apply discount code ", discountCode, " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
            className: "link link--colored",
            onClick: function onClick() {
              return _this.props.clearDiscountCode();
            }
          }, "Remove discount code")));
        } else {
          discountCodeAppliedSection = /*#__PURE__*/React.createElement("p", {
            className: "text text--xs text--discreet margin-top-xs margin-bottom-sm padding-right-md padding-left-md"
          }, /*#__PURE__*/React.createElement("span", {
            className: "icon-text-container"
          }, /*#__PURE__*/React.createElement("i", {
            className: "icon icon-info icon-green icon-sm"
          }), "Discount code ", discountCode, " applied ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
            className: "link link--colored",
            onClick: function onClick() {
              return _this.props.clearDiscountCode();
            }
          }, "Remove discount code")));
        }

        return discountCodeAppliedSection;
      }

      var setDiscountCodeRef = function setDiscountCodeRef(node) {
        _this.discountCode = node;
      };

      var hasError = discountCodeError && !inputFocused && !checkoutLoading ? ' tds-control--has-error' : '';
      var disabled = hasError || !discountCode || checkoutLoading ? 'tds-btn--is-disabled' : '';
      var buttonLabel = checkoutLoading ? /*#__PURE__*/React.createElement("i", {
        className: "tes-btn__icon icon-circle-o-notch icon-blue icon-spin"
      }) : 'Apply';
      var discountError = discountCodeError && !inputFocused && !checkoutLoading && discountCodeError;
      var discountCodeInput = /*#__PURE__*/React.createElement("div", {
        className: "discount-input-form"
      }, /*#__PURE__*/React.createElement(InputGroup, {
        self: {
          error: discountError
        },
        cta: /*#__PURE__*/React.createElement(Button, {
          theme: "secondary",
          onClick: function onClick() {
            return _this.onApplyDiscount();
          },
          className: "apply-discount-btn",
          disabled: !!disabled
        }, buttonLabel),
        customInput: /*#__PURE__*/React.createElement(Input, {
          type: "text",
          className: "tds-control uppercase-input ".concat(hasError),
          inputRef: setDiscountCodeRef,
          placeholder: "Enter discount code",
          value: discountCode,
          onFocus: function onFocus() {
            return _this.props.setInputFocus(true);
          },
          required: true,
          onChange: function onChange(e) {
            return _this.props.setDiscountCode(e.target.value);
          },
          onKeyPress: function onKeyPress(e) {
            return e.key === 'Enter' ? _this.onApplyDiscount() : null;
          }
        })
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "margin-bottom-ml"
      }, discountCodeInput);
    }
  }]);

  return DiscountCode;
}(Component);

DiscountCode.displayName = "DiscountCode";
export { DiscountCode as default };
DiscountCode.propTypes = {
  discountCode: PropTypes.string.isRequired,
  discountCodeError: PropTypes.string,
  inputFocused: PropTypes.bool.isRequired,
  discountCodeApplied: PropTypes.bool.isRequired,
  checkoutLoading: PropTypes.bool.isRequired,
  isPostalCodeNeeded: PropTypes.bool.isRequired,
  isEmailConfirmationNeeded: PropTypes.bool.isRequired,
  showDiscountCodeInput: PropTypes.func.isRequired,
  clearDiscountCode: PropTypes.func.isRequired,
  setInputFocus: PropTypes.func.isRequired,
  reloadCheckout: PropTypes.func.isRequired,
  setDiscountCode: PropTypes.func.isRequired
};